const value = Object.freeze({
  UnSet: 0,
  InventarioAT: 30,
});
export default value;
